{
  "billing": {
    "cartCleared": "Panier vidé",
    "discountApplied": "Remise appliquée",
    "lineDiscountUpdated": "Remise ligne mise à jour",
    "billHeld": "Facture mise en attente",
    "approvedRetry": "Approuvé — réessayez l'action"
  },
  "toast": {
    "billLoadedCompleteAtBilling": "Bill loaded — complete at billing",
    "heldBillCancelled": "Held bill annulé",
    "heldBillLoaded": "Held bill loaded",
    "saleSavedOfflineWillSyncWhenConnectionReturns": "Sale enregistré offline — will sync when connection returns",
    "scaleDisconnected": "Scale disconnected",
    "labelPrinterReadyUseSystemPrintDialog": "Label printer ready — utiliser system print dialog",
    "labelPrinterDisconnected": "Label printer disconnected",
    "receiptPrinterReadyUseSystemPrintDialog": "Receipt printer ready — utiliser system print dialog",
    "receiptPrinterDisconnected": "Receipt printer disconnected",
    "cashDrawerKickSent": "Cash drawer kick sent",
    "gatewaySaved": "Gateway enregistré",
    "counterCreated": "Counter créé",
    "modifiersSaved": "Modifiers enregistré",
    "shiftClosedSuccessfully": "Quart closed successfully",
    "shiftOpened": "Quart opened",
    "approvedRetryTheAction": "Approved — retry le action",
    "offlineQueueSynced": "Offline queue synced",
    "hardwareConfigSaved": "Hardware config enregistré",
    "customerAdded": "Client ajoutered",
    "couponApplied": "Coupon {{code}} applied",
    "returnProcessedSuccess": "{{type}} processed successfully",
    "scaleConnected": "Scale connected: {{label}}",
    "labelPrinterConnected": "Label printer connected: {{label}}",
    "receiptPrinterConnected": "Receipt printer connected: {{label}}",
    "promotionDiscountApplied": "Promotion discount {{amount}} applied",
    "invoiceCreated": "Invoice {{invoiceNumber}} créé",
    "offlineSaleSynced": "Synced offline sale {{factureNumber}}",
    "workingInStore": "Working in {{magasin}}"
  },
  "errors": {
    "invalidHeldBillData": "Invalid held bill data",
    "failedToLoadHeldBills": "Échec du chargement de held bills",
    "resumeFailed": "Échec de resume",
    "cancelFailed": "Échec de l'annulation",
    "selectABillingCounterBeforePayment": "Sélectionnez un billing counter before payment",
    "selectARegisteredCustomerForWalletPayment": "Sélectionnez un registered customer for wallet payment",
    "selectACreditEnabledCustomer": "Sélectionnez un credit-enabled customer",
    "customerIsNotEnabledForCreditSales": "Client is pas enabled pour credit sales",
    "insufficientPayment": "Insufficient paiement",
    "openShiftBeforePayment": "Open a cashier quart before taking paiement",
    "paymentCancelledInvoiceSavedAsPending": "Paiement annulé — facture enregistré as en attente",
    "splitPaymentRequiresAtLeastTwoTenders": "Split paiement requires at least two tenders",
    "invalidOrExpiredCoupon": "Invalid ou expired coupon",
    "gatewayPaymentFailed": "Échec de gateway payment",
    "couldNotQueueOfflineSale": "Impossible de queue offline sale",
    "checkoutFailed": "Échec de checkout",
    "offlineSaleRejectedByServer": "Offline sale rejeté by server",
    "invoiceNotFoundForThisStore": "Facture pas found pour ce magasin",
    "supervisorApprovalRequired": "Supervisor approbation requis",
    "failedToSaveGateway": "Échec de l'enregistrement de gateway",
    "failedToCreateCounter": "Échec de la création de counter",
    "failedToCloseShift": "Échec : close shift",
    "failedToOpenShift": "Échec : open shift",
    "holdFailed": "Échec de hold",
    "requestRejected": "Request rejeté",
    "failedToLoadApproval": "Échec du chargement de approval",
    "approvalFailed": "Échec de approval",
    "selectARegisteredCustomerForWallet": "Sélectionnez un registered customer for wallet",
    "selectAProductFirst": "Sélectionnez un product first",
    "labelPrintFailed": "Échec de label print",
    "failedToSaveHardwareConfig": "Échec de l'enregistrement de hardware config",
    "openBillingTerminalFirstToCreateADisplay": "Open billing terminal first à create a display session",
    "phoneNumberIsRequired": "Phone number is requis",
    "couldNotCreateCustomer": "Impossible de create customer",
    "insufficientWalletBalance": "Insufficient wallet balance ({{balance}} disponible)",
    "insufficientCredit": "Insufficient credit ({{available}} disponible)",
    "insufficientLoyaltyPoints": "Insufficient loyalty points ({{balance}} disponible)",
    "splitPaymentsMustEqualTotal": "Split paiements ({{sum}}) must equal total {{total}}"
  },
  "pages": {
    "payment": "Paiement",
    "billDiscount": "Remise sur facture",
    "quantity": "Quantité",
    "printBarcodeLabel": "Print barcode label",
    "weighingScale": "Weighing scale",
    "barcodeLabelPrinter": "Barcode / label printer",
    "thermalReceiptPrinter": "Thermal receipt printer",
    "cashDrawer": "Cash drawer",
    "customerDisplay": "Client display",
    "barcodeScanner": "Barcode scanner",
    "quickAddCustomer": "Quick ajouter client",
    "navigateEnterResumeEscBackTo": "↑↓ navigate · Saisir resume · Esc back à billing",
    "posAnalytics": "POS Analytique",
    "totalSales": "Total sales",
    "transactions": "Transactions",
    "avgBasket": "Avg basket",
    "topProduct": "Top produit",
    "posTerminalReports": "POS Terminal Rapports",
    "noPosActivity": "No POS activity",
    "adjustTheDateRangeOrComplete": "Adjust le date range ou complete sales at le terminal.",
    "returnsExchanges": "Returns & Exchanges",
    "returnRequiresApproval": "Return requires approbation",
    "processCustomerReturnsOrExchanges": "Process client returns ou exchanges",
    "posSetup": "POS Configuration",
    "noTaxConfiguration": "No tax configuration",
    "shiftManagement": "Quart Management",
    "selectAStoreFirst": "Sélectionnez un store first",
    "noBillingCountersYet": "No billing counters yet",
    "selectABillingCounter": "Sélectionnez un billing counter",
    "chooseYourStoreFromThePos": "Choose votre magasin de le POS tableau de bord, then return here à open ou close a quart.",
    "useTheCounterDropdownInThe": "Use le Counter dropdown in le top bar (next à votre name), then come back à open ou close votre quart.",
    "heldBillsForStore": "Factures en attente — {{store}}"
  },
  "shift": {
    "counterNumber": "Caisse n°{{id}}",
    "openNewShift": "Ouvrir un nouveau quart",
    "openShiftInfo": "L'ouverture d'un quart enregistre la caisse de départ et rattache toutes les transactions à cette session pour le rapprochement de fin de journée.",
    "openShift": "🟢 Ouvrir le quart",
    "closeShift": "Fermer le quart",
    "shiftOpened": "Quart ouvert",
    "byEmployee": "par {{name}}",
    "cashDiscrepancy": "Écart de caisse",
    "shortCash": "⚠ Manquant — espèces manquantes dans le tiroir",
    "overCash": "⚠ Excédent — plus d'espèces que prévu",
    "status": {
      "OPEN": "Ouvert",
      "ACTIVE": "Actif",
      "CLOSED": "Fermé"
    },
    "metrics": {
      "openingCash": "Caisse d'ouverture",
      "cashSales": "Ventes espèces",
      "expected": "Prévu",
      "totalSales": "Ventes totales",
      "transactions": "Transactions",
      "returns": "Retours",
      "cardSales": "Ventes carte",
      "upiSales": "Ventes UPI"
    }
  },
  "statusBar": {
    "barcodeScanner": "Lecteur de codes-barres (USB HID)",
    "weighingScale": "Balance",
    "labelPrinter": "Imprimante d'étiquettes",
    "receiptPrinter": "Imprimante de reçus",
    "customerDisplay": "Écran client"
  },
  "terminalNav": {
    "billing": "Caisse",
    "held": "En attente",
    "shift": "Quart",
    "returns": "Retours",
    "analytics": "Analyses",
    "setup": "Configuration",
    "dashboard": "Tableau de bord",
    "terminal": "Terminal {{module}}",
    "toggleTheme": "Changer le thème"
  },
  "heldBills": {
    "cancelTitle": "Annuler la facture en attente ?",
    "cancelMessage": "Libérer la réservation de stock pour {{reference}} ? Cette action est irréversible.",
    "holdNumber": "Attente n°{{id}}",
    "loading": "Chargement…",
    "empty": "Aucune facture en attente. Appuyez sur Esc pour revenir à la caisse.",
    "enterResume": "Entrée → Reprendre",
    "footerShortcuts": "Entrée ouvrir · Esc caisse ·",
    "shortcuts": {
      "backToBilling": "Retour à la caisse",
      "resumeBill": "Reprendre la facture",
      "navigation": "Navigation",
      "holdBills": "Factures en attente"
    }
  },
  "paymentMethods": {
    "cash": "Espèces",
    "upi": "UPI",
    "card": "Carte",
    "wallet": "Portefeuille",
    "credit": "Crédit (compte)"
  },
  "labels": {
    "commentsOptional": "Commentaires (facultatif)",
    "amount": "Montant",
    "paymentMethodOr14": "Paiement method (↑↓ ou 1–4)",
    "amountReceived": "Amount received",
    "loyaltyPointsToRedeem1Pt": "Loyalty points à redeem (1 pt = 1 unit off)",
    "billDiscount": "Remise sur facture",
    "coupon": "Coupon",
    "discountAmount": "Remise amount",
    "quantity": "Quantité",
    "cart": "Panier",
    "item": "Article",
    "qty": "Qté",
    "total": "Total",
    "productSuggestions": "Produit suggestions",
    "scanBarcodeOrTypeSkuName": "Scan barcode ou type SKU / name",
    "scan": "Scan",
    "scale": "Scale",
    "label": "Label",
    "receipt": "Receipt",
    "display": "Display",
    "selectCounter": "Select counter",
    "searchPhoneNameOrCode": "Search phone, name, ou code",
    "phoneNumber": "Phone number *",
    "customerNameOptional": "Client name (optional)",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "invoiceIdOrNumber": "Facture ID ou number",
    "reason": "Motif",
    "customerReasonForReturn": "Client reason pour return...",
    "displayName": "Nom affiché",
    "closingCashInDrawer": "Closing cash in drawer",
    "discrepancyReason": "Discrepancy reason",
    "notesOptional": "Notes (facultatif)",
    "openingCashInDrawer": "Trésorerie initiale in drawer",
    "enterAmountCounted": "Saisissez amount counted",
    "explainTheDiscrepancy": "Explain le discrepancy...",
    "anyShiftNotes": "Any quart notes...",
    "eGFloatFromSafe": "E.g. float de safe",
    "lineDiscount": "Line discount",
    "splitPayment": "Paiement fractionné (plusieurs moyens)",
    "tenderNumber": "Paiement {{number}}",
    "splitTotal": "Total fractionné :",
    "walletAvailable": "Portefeuille : {{amount}} disponible",
    "creditAvailable": "Crédit : {{amount}} disponible",
    "creditLimit": "limite {{amount}}",
    "gatewayCheckoutAfterInvoice": "Ouvre le paiement {{provider}} après la création de la facture.",
    "numberOfLabels": "Nombre d'étiquettes"
  },
  "dialogs": {
    "confirmPayment": "Confirmer le paiement",
    "printLabels": "Imprimer les étiquettes"
  },
  "formActions": {
    "cancelBill": "Annuler la facture",
    "addToCart": "Ajouter au panier",
    "cancelEsc": "Annuler (Esc)",
    "completeShortcut": "Terminer (Entrée / Ctrl+Entrée)",
    "apply": "Appliquer",
    "applyEnter": "Appliquer (Entrée)",
    "printLabel": "Imprimer l'étiquette",
    "multipleCopies": "Copies multiples…"
  },
  "empty": {
    "noProductsTryAnother": "Aucun produit — essayez un autre code ou nom",
    "scanOrSearchToAddItems": "Scannez ou recherchez pour ajouter des articles"
  },
  "hardware": {
    "enabled": "Activé",
    "connectedWithLabel": "● Connecté{{label}}",
    "notConnected": "○ Non connecté",
    "testLabelPrint": "Tester l'impression d'étiquette",
    "productId": "ID produit",
    "testPrintFailed": "Échec du test d'impression",
    "scaleDescription": "Balance USB/RS-232 via Web Serial (Chrome/Edge). Le poids se remplit automatiquement sur l'écran de caisse.",
    "connectScale": "Connecter la balance",
    "webSerialNotSupported": "Web Serial non pris en charge — utilisez la saisie manuelle du poids",
    "disconnect": "Déconnecter",
    "labelPrinterDescription": "Imprime les étiquettes produit depuis la caisse (F11 sur le produit sélectionné). Utilise un format d'étiquette 50×30 mm.",
    "connectBrowserPrint": "Connecter (impression navigateur)",
    "connectUsbSerial": "Connecter (USB série)",
    "testPrint": "Tester l'impression",
    "receiptPrinterDescription": "Les reçus s'impriment automatiquement après chaque vente via la boîte d'impression du navigateur.",
    "viaReceiptPrinterSerial": "Via l'imprimante de reçus série",
    "requiresSerialReceiptPrinter": "Nécessite une imprimante de reçus série",
    "cashDrawerDescription": "S'ouvre sur les ventes en espèces lorsqu'elle est connectée à une imprimante de reçus ESC/POS série.",
    "testDrawerKick": "Tester l'ouverture du tiroir",
    "secondScreenWindow": "Deuxième écran / fenêtre",
    "customerDisplayDescription": "S'ouvre automatiquement au démarrage de la caisse. Affiche le total du panier au client sur un deuxième écran ou une fenêtre.",
    "openCustomerDisplay": "Ouvrir l'écran client",
    "usbHidKeyboardMode": "Mode clavier USB HID",
    "scannerDescription": "Plug-and-play — aucun appairage requis. Les scanners agissent comme un clavier et alimentent le champ de recherche produit sur l'écran de caisse (F1)."
  }
}
